import * as Yup from 'yup'

import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'
import { DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH } from '../Document.constants'

import { DOCUMENT_EDIT_ACTION_TITLE_FIELD_NAME } from './DocumentEditActionModal.constants'

export function getDocumentEditInitialValues(values) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...values,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
  }
}

export function getDocumentEditValidationSchema({ initialValues, t }) {
  return Yup.object({
    [DOCUMENT_EDIT_ACTION_TITLE_FIELD_NAME]: Yup.string()
      .max(
        DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH,
        t('Error.MaxLengthKey', {
          length: DOCUMENT_FOLDER_FORM_NAME_FIELD_MAX_LENGTH,
        })
      )
      .required(true),
  }).concat(
    formValidationSchemaNoChanged({
      initialValues,
    })
  )
}
